<img [src]="iconBase64 ?? NoImage | safe:'url'" [style.width]="size"/>
